// Chat Toggle Button Component
// The floating button that opens/closes the chat widget

import { MessageSquare, X } from 'lucide-react';

const ChatToggleButton = ({ isOpen, onClick }) => {
  return (
    <div className="flex flex-col items-center gap-2">
      {!isOpen && (
        <div className="bg-slate-900 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg animate-bounce-gentle relative">
          Try Our Demo - It&apos;s Free
          <div className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-slate-900"></div>
        </div>
      )}
      <div className={`relative ${!isOpen ? 'animate-button-bounce' : ''}`}>
        {/* Notification Badge */}
        {!isOpen && (
          <span className="absolute -top-1 -right-1 w-6 h-6 bg-red-500 rounded-full text-white text-xs font-bold flex items-center justify-center border-[3px] border-white shadow-lg animate-badge-pulse z-10">
            1
          </span>
        )}
        <button
          onClick={onClick}
          className={`w-[70px] h-[70px] rounded-full bg-teal-500 hover:bg-teal-600 shadow-lg flex items-center justify-center text-white transition-all hover:scale-105 ${!isOpen ? 'widget-glow-pulse' : ''}`}
          data-testid="chat-toggle-btn"
          aria-label={isOpen ? "Close chat" : "Open chat demo"}
        >
          {isOpen ? (
            <X className="w-7 h-7" aria-hidden="true" />
          ) : (
            <MessageSquare className="w-8 h-8" aria-hidden="true" />
          )}
        </button>
      </div>
    </div>
  );
};

export default ChatToggleButton;
